import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ExclamationIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 5v9"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="12" cy="19" r="1.25" fill="currentColor" />
  </SvgIcon>
);

export default ExclamationIcon;
